{
  "stats": {
    "title": "Статус устройств",
    "connection": "Есть соединение",
    "noConnection": "Нет соединения",
    "unknown": "Неизвестен",
    "inactive": "Неактивен",
    "sync": "Синхронизировано",
    "syncError": "Ошибка в синхронизации"
  },
  "alarms": {
    "title": "Тревоги",
    "info": "Инфо",
    "warning": "Предупреждение",
    "error": "Ошибка"
  },
  "attacks": {
    "title": "Последние {{count}} атак"
  },
  "charts": {
    "title": "Топ {{count}} устройств по утилизации"
  }
}